// Banner em vídeo do topo do cardápio (pedido do dono, 23/10/2026).
// Confere a duração e tira a capa (1º quadro, recortado em 3,5:1) no navegador,
// antes de enviar: o lojista sabe na hora se o vídeo passou do limite, e a capa
// não depende do ffmpeg do servidor.

export const VIDEO_SEGUNDOS = 15;
export const VIDEO_MAX_MB = 45;
// .mov do iPhone às vezes chega sem tipo: a extensão também vale
export const ehVideo = (file) => /^video\//.test(file?.type || "") || /\.(mp4|mov|webm|m4v)$/i.test(file?.name || "");
// Erro com frase pronta para o lojista (o hook mostra a mensagem como veio)
const erro = (msg) => Object.assign(new Error(msg), { paraOLojista: true });
// Navegador que não decodifica o vídeo às vezes nem avisa: não deixa a tela presa
const PRAZO_MS = 10000;

export function lerVideoBanner(arquivo) {
  return new Promise((resolve, reject) => {
    if (arquivo.size > VIDEO_MAX_MB * 1024 * 1024) {
      reject(erro(`O vídeo tem ${Math.round(arquivo.size / 1048576)} MB. O limite é ${VIDEO_MAX_MB} MB.`));
      return;
    }
    const url = URL.createObjectURL(arquivo);
    const v = document.createElement("video");
    v.preload = "auto"; v.muted = true; v.playsInline = true; v.src = url;
    let prazo = null;
    const limpar = () => { clearTimeout(prazo); URL.revokeObjectURL(url); };
    prazo = setTimeout(() => { limpar(); reject(erro("Não consegui ler este vídeo. Tente outro, em MP4.")); }, PRAZO_MS);
    v.onerror = () => { limpar(); reject(erro("Não consegui abrir este vídeo. Tente MP4 ou MOV.")); };
    v.onloadedmetadata = () => {
      // Duração desconhecida (alguns WebM): segue, o servidor corta em 15 s
      const finita = Number.isFinite(v.duration);
      if (finita && v.duration > VIDEO_SEGUNDOS + 0.5) {
        limpar();
        reject(erro(`O vídeo tem ${Math.round(v.duration)} s. O limite é ${VIDEO_SEGUNDOS} s: corte no celular e envie de novo.`));
        return;
      }
      v.currentTime = finita ? Math.min(0.1, v.duration / 2) : 0.1;
    };
    v.onseeked = () => {
      // Mesmo recorte que o servidor faz no vídeo: centro, 3,5 por 1
      const w = v.videoWidth, h = v.videoHeight;
      const cw = Math.min(w, h * 3.5), ch = Math.min(h, w / 3.5);
      const c = document.createElement("canvas");
      c.width = 1800; c.height = 514;
      c.getContext("2d").drawImage(v, (w - cw) / 2, (h - ch) / 2, cw, ch, 0, 0, 1800, 514);
      c.toBlob((b) => {
        limpar();
        b ? resolve(new File([b], "capa.jpg", { type: "image/jpeg" })) : reject(erro("Não consegui gerar a capa do vídeo."));
      }, "image/jpeg", 0.85);
    };
  });
}
